import { Navigate } from "react-router-dom";

function getRole() {
  try {
    const auth = JSON.parse(localStorage.getItem("auth") || "null");
    return String(auth?.role || "").toUpperCase();
  } catch {
    return "";
  }
}

export default function TutorRoute({ children }) {
  const role = getRole();
  return role === "TUTOR" ? children : <Navigate to="/dashboard" replace />;
}
